var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 212,
    viewBox: "0 0 216 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 37.6586,
    ry: 41.2026,
    transform: "matrix(0.499891 -0.866088 0.865963 0.500109 54.5051 70.5574)",
    fill: "#0BAB43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.767 59.949C137.164 60.3995 139.417 60.6981 140.216 61.3175C150.117 63.5309 161.538 67.4867 174.882 73.4511C212.274 95.0458 226.192 140.957 205.968 175.996C185.744 211.035 139.037 221.933 101.644 200.339C90.064 193.651 80.7352 184.631 73.9748 174.324C67.6022 166.816 62.6296 159.297 56.6313 150.227C55.4234 148.401 54.1738 146.511 52.8628 144.546C51.7883 142.953 49.5145 139.751 46.6935 135.778C38.8292 124.702 26.7117 107.636 24.4651 102.745C22.5023 98.415 20.4755 93.855 18.9667 89.2271C11.886 76.8747 11.1753 61.7113 18.4582 49.0933C29.6598 29.686 55.5299 23.6494 76.2407 35.6102C100.402 55.5245 122.92 58.5106 133.767 59.949Z",
    fill: "url(#paint0_linear_321_45093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.151 191.118C135.989 191.118 123.262 187.712 110.099 180.725C106.612 178.891 98.0698 174.087 93.9728 169.982C80.0256 155.92 67.4732 140.024 55.4437 121.508C51.9569 116.092 46.4652 111.027 42.1067 107.184C32.6924 98.9737 19.7912 87.7067 17.5248 71.7233C15.8686 59.1463 21.6218 46.3072 32.6924 38.0971C39.4044 33.1187 47.4241 30.4111 55.1822 30.4111C61.4584 30.4111 67.4732 32.1579 72.7034 35.4769C76.8875 38.1845 80.3743 41.7654 83.4253 44.9097C86.6506 48.2287 86.5626 48.316 93.1007 53.1198C97.0229 56.0015 98.7668 57.4868 98.7668 57.4868C98.7668 57.4868 100.51 58.3602 102.689 59.2336C105.74 59.845 104.694 60.0197 105.74 59.845C108.53 59.4956 109.489 59.845 112.366 59.845C145.839 59.845 183.496 73.4702 201.453 105.874C207.294 116.355 213.744 132.338 211.129 148.409C208.165 166.75 193.957 181.336 173.21 187.363C164.755 189.895 156.997 191.118 149.151 191.118Z",
    fill: "url(#paint1_linear_321_45093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5208 164.155C102.471 167.121 109.934 171.397 113.492 173.316C132.843 183.612 150.632 185.008 169.723 179.424C184.648 175.061 198.706 164.242 201.396 147.489C203.305 135.361 199.14 122.099 192.805 110.669C174.929 78.3849 156.785 70.9413 113.097 67.0646C107.109 67.7626 94.9217 63.7264 88.9342 61.2833C80.5169 57.7932 75.2236 48.2826 67.5005 43.3091C57.7816 37.0269 45.8933 39.2955 37.5628 45.4905C30.1001 50.9874 24.4597 60.4108 25.9349 70.8812C27.6704 83.2711 38.0835 92.7817 47.4553 100.896C52.8354 105.608 58.389 110.93 62.294 117.038C73.2277 134.14 85.4631 149.933 99.5208 164.155Z",
    fill: "url(#paint2_linear_321_45093)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8996 38.8045C75.8952 38.8141 75.8909 38.8237 75.8866 38.8333C72.7067 45.8978 65.7694 51.2141 58.0805 52.3053C50.3668 53.4803 46.2669 53.2907 34.8828 47.194L56.808 30.6338C62.0975 31.0649 67.1405 32.7509 71.6106 35.5828C73.1278 36.5629 74.5533 37.6575 75.8996 38.8045Z",
    fill: "url(#paint3_linear_321_45093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2313 47.5206C32.0225 39.9402 31.4314 31.2983 33.5161 23.3732C35.6857 15.4283 40.5511 8.28501 47.1821 3.3262C49.4707 1.62505 52.8127 0.21459 55.0932 1.92001C56.2009 2.82513 56.7288 4.31411 57.0471 5.67304C58.8973 13.5718 56.8272 21.9415 52.726 28.9057C48.6248 35.8698 42.7022 41.5586 36.3656 46.6275C36.4505 46.6076 36.5355 46.5877 35.2313 47.5206Z",
    fill: "url(#paint4_linear_321_45093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9632 1.86587C64.1237 5.74258 66.691 13.088 67.4228 20.8009C68.1546 28.5139 64.7565 36.5676 58.615 41.322C52.4934 46.1615 48.1412 47.6963 35.2326 48.0339",
    fill: "url(#paint5_linear_321_45093)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8299 1.82267C61.7376 5.31062 65.8751 12.3823 66.607 20.0952C67.3388 27.8082 63.9407 35.8619 57.7992 40.6163C51.6776 45.4557 48.0211 47.3205 35.1126 47.6581",
    fill: "url(#paint6_linear_321_45093)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.261 83.0799C137.532 80.5789 128.235 82.1303 120.046 86.0208C111.767 89.9112 105.108 97.4142 102.769 106.399C100.429 115.292 102.499 125.018 107.268 132.799C115.817 146.786 133.635 154.196 149.023 149.564C164.411 144.933 175.569 128.074 173.409 111.772C171.25 95.469 158.229 87.3409 146.261 83.0799Z",
    fill: "url(#paint7_linear_321_45093)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.065 81.5954C138.592 79.2476 129.569 80.704 121.621 84.3562C113.586 88.0084 107.122 95.0521 104.851 103.487C102.581 111.835 104.589 120.966 109.219 128.27C117.516 141.401 134.81 148.357 149.745 144.009C164.681 139.662 175.511 123.835 173.415 108.531C171.319 93.2259 158.681 85.5955 147.065 81.5954Z",
    fill: "url(#paint8_radial_321_45093)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.425 90.4873C113.005 95.5078 114.814 100.426 117.52 104.715C125.805 117.888 143.072 124.866 157.985 120.505C163.959 118.757 169.276 115.162 173.368 110.492C174.332 125.212 163.812 139.94 149.536 144.115C134.624 148.477 117.357 141.498 109.072 128.326C104.45 120.998 102.444 111.839 104.711 103.464C106.033 98.5319 108.777 94.0738 112.425 90.4873Z",
    fill: "url(#paint9_linear_321_45093)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9952 68.0658C89.0127 68.0357 89.0303 68.0057 89.0478 67.9756C89.7956 66.3569 92.679 66.5499 95.5193 68.3701C98.3008 70.1559 99.9865 72.8735 99.3151 74.4965C99.2975 74.5266 99.28 74.5566 99.28 74.5566C98.5322 76.1753 95.6487 75.9824 92.8084 74.1622C90.0269 72.3764 88.3119 69.6416 88.9952 68.0658Z",
    fill: "url(#paint10_radial_321_45093)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5709 92.3723C65.587 92.3414 65.6031 92.3106 65.6192 92.2797C66.2893 90.6273 69.1786 90.6831 72.1021 92.3663C74.9653 94.018 76.7781 96.6524 76.1844 98.3055C76.1683 98.3363 76.1522 98.3672 76.1522 98.3672C75.4821 100.02 72.5928 99.9638 69.6693 98.2806C66.8222 96.5981 64.9933 93.9945 65.5709 92.3723Z",
    fill: "url(#paint11_radial_321_45093)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3308 79.2791C85.5101 78.022 87.9143 78.9223 88.5295 80.8212C89.209 82.9494 88.9077 85.1594 87.4783 86.6741C86.0656 88.1717 83.896 88.6337 81.7371 88.0718C79.8092 87.5673 78.801 85.1866 79.9637 83.9467C79.9637 83.9467 81.9728 82.5947 82.5018 82.0074C83.0643 81.3858 84.3308 79.2791 84.3308 79.2791Z",
    fill: "#05581D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8722 82.7389C88.9264 84.2136 88.4786 85.6142 87.4782 86.6743C86.3679 87.8513 84.79 88.3887 83.1171 88.2919C83.0965 88.0832 83.1056 87.8655 83.1491 87.6429C83.533 85.7263 84.8182 84.0248 86.7758 83.2091C87.4609 82.9235 88.1696 82.7702 88.8722 82.7389Z",
    fill: "#A0E7A4",
    fillOpacity: 0.26
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_45093",
    x1: 113.806,
    y1: 48.9545,
    x2: 191.018,
    y2: 252.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_45093",
    x1: 16.9125,
    y1: 20.1907,
    x2: 127.238,
    y2: 210.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC783",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_45093",
    x1: 113.781,
    y1: 39.5752,
    x2: 151.017,
    y2: 200.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7F19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89D47F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_321_45093",
    x1: 45.3478,
    y1: 41.9738,
    x2: 78.2183,
    y2: 29.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0192042,
    stopColor: "#25A351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C47C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_321_45093",
    x1: 40.5348,
    y1: 3.83053,
    x2: 49.9654,
    y2: 44.0673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_321_45093",
    x1: 45.002,
    y1: 4.20054,
    x2: 54.718,
    y2: 45.6551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FF578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BCC36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_321_45093",
    x1: 65.5329,
    y1: 25.4775,
    x2: 48.8371,
    y2: 21.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ED139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B32B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_321_45093",
    x1: 109.222,
    y1: 79.3992,
    x2: 166.323,
    y2: 172.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45BC6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC783",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_321_45093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.906 85.9434) rotate(67.7615) scale(53.0795 57.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#D2996F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D08248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_321_45093",
    x1: 129.655,
    y1: 90.3266,
    x2: 135.648,
    y2: 145.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2986E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8744E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_321_45093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.1639 71.2661) rotate(30.2884) scale(6.08517 3.19467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A8228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6908"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_321_45093",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.8857 95.3235) rotate(27.566) scale(6.0851 3.19471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A8228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6908"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading7);
export default __webpack_public_path__ + "static/media/loading_7.bb77a43af2b363004f9113d94a36a6a2.svg";
export { ForwardRef as ReactComponent };